export default __webpack_public_path__ + "static/media/homepage_main.4948c0bb.png";